var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLirariLandingPageDesktopLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 707,
    height: 355,
    viewBox: "0 0 707 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.952 317.468C220.158 292.419 699.974 277.329 705 304.5",
    stroke: "black",
    strokeWidth: 3,
    strokeDasharray: "6 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04323 191.044C-2.65067 171.271 383.078 232.552 388 254",
    stroke: "black",
    strokeWidth: 3,
    strokeDasharray: "6 12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M306.219 339.893C341.428 339.893 369.97 311.35 369.97 276.141C369.97 240.932 341.428 212.39 306.219 212.39C271.01 212.39 242.468 240.932 242.468 276.141C242.468 311.35 271.01 339.893 306.219 339.893Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M371.133 4.00005V10.2888C375.007 58.0933 462.393 131.356 449.751 241C431.9 144.672 408.733 145.142 371.133 127.405V10.2888C370.959 8.14154 370.953 6.04561 371.133 4.00005Z",
    fill: "url(#paint0_linear_88_16)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M370.987 3.51294L369.994 272.513M371.133 4.00005V10.2888M371.133 4.00005C370.953 6.04561 370.959 8.14154 371.133 10.2888M371.133 4.00005V127.405M371.133 4.00005C366.955 51.5849 462.961 126.431 449.751 241M371.133 10.2888C375.007 58.0933 462.393 131.356 449.751 241M371.133 10.2888V127.405M449.751 241C431.9 144.672 408.733 145.142 371.133 127.405M306.219 339.893C341.428 339.893 369.97 311.35 369.97 276.141C369.97 240.932 341.428 212.39 306.219 212.39C271.01 212.39 242.468 240.932 242.468 276.141C242.468 311.35 271.01 339.893 306.219 339.893Z",
    stroke: "url(#paint1_linear_88_16)",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M247.006 263.675C276.067 304.836 296.668 317.579 338.942 327.043M256.875 241.6C286.796 280.754 316.021 298.226 356.862 309.124M275.574 224.2C305.347 263.029 325.547 275.69 366.077 286.581M300.1 215.725C320.179 244.863 334.603 253.75 364.393 260.04M340.011 226.106C266.712 217.157 238.815 270.153 271.938 326.005M340.164 226.567C294.605 236.597 263.868 287.601 271.938 326.264M340.617 226.19L272.574 326.436M340.5 226.278C349.496 273.754 313.705 321.979 272.407 326.867M340.555 225.988C379.499 294.085 340.782 340.452 272.331 326.816",
    stroke: "url(#paint2_linear_88_16)",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M387.901 254C392.589 273.605 229.916 339.068 225 317.802",
    stroke: "black",
    strokeWidth: 3,
    strokeDasharray: "6 12"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_88_16",
    x1: 346.734,
    y1: 3.51294,
    x2: 346.734,
    y2: 339.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#9E0EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#00FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8830C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_88_16",
    x1: 346.734,
    y1: 3.51294,
    x2: 346.734,
    y2: 339.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#9E0EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#00FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8830C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_88_16",
    x1: 306.542,
    y1: 215.725,
    x2: 306.542,
    y2: 329.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#9E0EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#00FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8830C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLirariLandingPageDesktopLogo);
export default __webpack_public_path__ + "static/media/lirari-landing-page-desktop-logo.9599a001e44a07797435279ebf960700.svg";
export { ForwardRef as ReactComponent };